import * as React from 'react';
import { SVGProps } from 'react';
import { withForgeIconProps } from './ForgeIconProps';
interface SVGRProps {
  title?: string;
  titleId?: string;
}

const SvgHelpButtonSmall = ({
  title,
  titleId,
  ...props
}: SVGProps<SVGSVGElement> & SVGRProps): JSX.Element => (
  <svg
    width={16}
    height={16}
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className="fi_c_icon"
    role="img"
    aria-labelledby={titleId}
    {...props}
  >
    {title ? <title id={titleId}>{title}</title> : null}
    <path
      d="M5.00291 5.80375C4.96083 6.35443 5.37312 6.83496 5.9238 6.87704C6.47448 6.91912 6.95501 6.50682 6.99709 5.95614L5.00291 5.80375ZM6.09998 5.37995L5.15401 5.05547L5.15028 5.06679L6.09998 5.37995ZM9.42004 4.53009L10.1219 3.81773L10.108 3.80409L10.0937 3.79101L9.42004 4.53009ZM9.42004 7.18L8.71822 6.46761L8.71294 6.47289L9.42004 7.18ZM8.42004 7.91999L9.01458 8.72406L9.02108 8.71925L9.02749 8.71434L8.42004 7.91999ZM6.92228 9.06696C6.95923 9.61801 7.43589 10.0348 7.98694 9.99782C8.53799 9.96088 8.95475 9.48422 8.9178 8.93317L6.92228 9.06696ZM14 8C14 11.3137 11.3137 14 8 14V16C12.4183 16 16 12.4183 16 8H14ZM8 14C4.68629 14 2 11.3137 2 8H0C0 12.4183 3.58172 16 8 16V14ZM2 8C2 4.68629 4.68629 2 8 2V0C3.58172 0 0 3.58172 0 8H2ZM8 2C11.3137 2 14 4.68629 14 8H16C16 3.58172 12.4183 0 8 0V2ZM6.99709 5.95614C7.00394 5.86657 7.0216 5.77825 7.04968 5.69311L5.15028 5.06679C5.0715 5.30567 5.02206 5.55314 5.00291 5.80375L6.99709 5.95614ZM7.04588 5.7044C7.1023 5.5399 7.19885 5.39185 7.3269 5.27363L5.97022 3.80414C5.5988 4.14704 5.31821 4.57698 5.15407 5.0555L7.04588 5.7044ZM7.3269 5.27363C7.45489 5.15546 7.61012 5.07105 7.77866 5.0279L7.28262 3.09039C6.79262 3.21584 6.34169 3.46118 5.97022 3.80414L7.3269 5.27363ZM7.77866 5.0279C7.94722 4.98475 8.12397 4.98418 8.29299 5.0263L8.77659 3.08565C8.286 2.96339 7.7726 2.96494 7.28262 3.09039L7.77866 5.0279ZM8.29299 5.0263C8.46181 5.06837 8.61769 5.15184 8.74643 5.26918L10.0937 3.79101C9.71998 3.45044 9.26738 3.20795 8.77659 3.08565L8.29299 5.0263ZM8.71824 5.24246C8.79941 5.32243 8.86383 5.41767 8.90788 5.52291L10.7528 4.75065C10.6064 4.40095 10.392 4.08388 10.1219 3.81773L8.71824 5.24246ZM8.90788 5.52291C8.95193 5.62814 8.97461 5.74109 8.97461 5.85505H10.9746C10.9746 5.47581 10.8992 5.10037 10.7528 4.75065L8.90788 5.52291ZM8.97461 5.85505C8.97461 5.969 8.95193 6.08195 8.90788 6.18718L10.7528 6.95944C10.8992 6.60972 10.9746 6.23428 10.9746 5.85505H8.97461ZM8.90788 6.18718C8.86383 6.29242 8.79941 6.38766 8.71824 6.46763L10.1219 7.89236C10.392 7.62621 10.6064 7.30914 10.7528 6.95944L8.90788 6.18718ZM8.71294 6.47289C8.6372 6.54863 8.53647 6.62571 8.37715 6.73386C8.24011 6.82689 8.01248 6.97278 7.81259 7.12563L9.02749 8.71434C9.16761 8.6072 9.29498 8.52809 9.50043 8.38862C9.68362 8.26427 9.91289 8.10136 10.1272 7.8871L8.71294 6.47289ZM7.82551 7.11592C7.52351 7.33921 7.2824 7.63491 7.12452 7.97594L8.93945 8.81618C8.95632 8.77975 8.98213 8.74805 9.01458 8.72406L7.82551 7.11592ZM7.12452 7.97594C6.96662 8.31699 6.89716 8.69225 6.92228 9.06696L8.9178 8.93317C8.9151 8.89286 8.9226 8.85258 8.93945 8.81618L7.12452 7.97594Z"
      fill={props.color}
    />
    <path
      d="M8 13C8.55228 13 9 12.5523 9 12C9 11.4477 8.55228 11 8 11C7.44772 11 7 11.4477 7 12C7 12.5523 7.44772 13 8 13Z"
      fill={props.color}
    />
  </svg>
);

SvgHelpButtonSmall.displayName = 'SvgHelpButtonSmall';
const HelpButtonSmall = withForgeIconProps(SvgHelpButtonSmall, {
  name: 'HelpButton',
  usage: 'Use in a Button to get helpful information.',
  related: 'question, guide, tutorial, help',
  isLabelRequired: false,
  isNeutralInteractive: false,
  size: 'small',
});
export default HelpButtonSmall;
